/* istanbul ignore file */
const invoiceFilterValidation = {
  invoiceDate: {
    type: 'object',
    properties: {
      ge: {
        type: 'date',
        maxDate: {
          value: '$invoiceDate.le',
          message: 'Please choose date before or at "to" date',
        },
      },
      le: {
        type: 'date',
        minDate: {
          value: '$invoiceDate.ge',
          message: 'Please choose date after or at "from" date',
        },
      },
    },
  },
};

export default invoiceFilterValidation;
